import React, { createContext, useContext } from "react";

const FormContext = createContext(null);

export const IForm = ({ form, children }) => (
  <FormContext.Provider value={form}>{children}</FormContext.Provider>
);

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) throw new Error("useFormContext must be used within an IForm");
  return context;
};
